import styled from 'styled-components';

export const HelpfulTools = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 6%;

  @media (max-width: 720px) {
    display: block;
    padding: 0;
  }

  .tools_grid {
    flex-basis: ${(props) => (props.stage ? '100%' : '32%')};
    position: relative;
    &:after {
      content: '';
      width: 1px;
      height: 316px;
      background-color: hsl(0deg, 0%, 0%, 10%);
      position: absolute;
      top: 0;
      right: -11px;

      @media (max-width: 720px) {
        width: 0;
      }
    }

    &:nth-last-child(1) {
      &:after {
        width: 0;
      }
    }
  }
`;

export const ToolsContainer = styled.ul`
  display: flex;
  justify-content: ${(props) =>
    props.stage ? 'space-around' : 'space-between'};
  flex-wrap: wrap;
  padding: 0 16px;

  @media (max-width: 720px) {
    border-right: none;
    flex-wrap: nowrap;
    overflow-x: scroll;
    justify-content: flex-start;
    padding: 0 10px;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ToolsList = styled.li`
  flex: ${(props) => (props.stage ? '0 0 0' : '0 0 calc(50% - 20px)')};
  text-align: center;
  margin: 20px 0;
  transition: all 0.18s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s;
  cursor: pointer;

  @media (max-width: 720px) {
    flex: 0 0 calc(28% - 20px);
    margin: 20px 5px 20px 0;
    cursor: default;
  }

  &.toolEffect {
    opacity: 0.5;
  }

  img {
    width: 100%;
    height: auto;
    max-width: clamp(60px, 6vw, 66px);
    height: clamp(60px, 6vw, 66px);
    object-fit: contain;
  }

  &:hover {
    transform: scale(1.03);
  }
`;

export const ToolName = styled.p`
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 10px 0px 0;
  width: 100px;
  margin: auto;
  text-transform: capitalize;
`;
